import { CustomModalDto } from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { DOMAIN_CUSTOM_MODALS } from "../domain";

import { customModalsApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";

export const ACTION_GET_CUSTOM_MODALS = "GET_CUSTOM_MODALS";

export const fetchCustomModals = async (): Promise<CustomModalDto[]> => {
  const response = await customModalsApi.customModalsControllerGetCustomModals();

  return response.data;
};

export const useGetCustomModals = (): {
  customModals: CustomModalDto[] | undefined;
  isLoadingCustomModals: boolean;
  isFetchingCustomModals: boolean;
  isSuccessCustomModals: boolean;
} => {
  const queryResult = useQuery<CustomModalDto[], Error>({
    queryKey: [DOMAIN_CUSTOM_MODALS, ACTION_GET_CUSTOM_MODALS],
    queryFn: fetchCustomModals,
    staleTime: TANSTACK_QUERY_STALE_TIME,
  });

  return {
    customModals: queryResult.data,
    isLoadingCustomModals: queryResult.isLoading,
    isFetchingCustomModals: queryResult.isFetching,
    isSuccessCustomModals: queryResult.isSuccess,
  };
};
